module.exports = __webpack_public_path__ + "img/mp-solution-icon-2.d8c7e65d.png";